import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * The world in 3D under the free orbit camera (render3d, docs/archive/3D.md), instead of the 2.5D
     * renderer. Off by default while it is built; `?render=3d` turns it on for one page.
     */
    render3d: boolean;
  }
}

defineSetting({
  key: 'render3d',
  default: false,
  order: 130,
  menu: {
    group: 'visual',
    label: 'โลกสามมิติ กล้องหมุนอิสระ (ทดลอง)',
    note: () => 'มีผลหลังโหลดเกมใหม่',
  },
});
